import React from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
	UsersList
} from '../../components/users/';

class Users extends React.Component {

	constructor(props) {
    super(props);

  }

	componentDidMount() {

	}

	render() {
		return (
			<div>
				<Row>
					<Col md="12">
            <UsersList />
					</Col>
				</Row>
			</div>
		);
	}
}

export default Users;
